<template>
  <div
    class="popup-info"
    v-if="isShow"
  >
    <div
      class="info-wrap"
      @click="closePop()"
    >
      <div
        class="info-content"
        @click.stop=""
      >
        <div class="content-title">
          <p class="popup-info-title">{{contentObj.name}}</p>
          <img
            class="popup-info-closeicon"
            @click="closePop()"
            :src="closeimg"
            alt=""
          >
        </div>
        <div class="content-wrap">
          <div class="content-txt">
            <div class="content-secondtitle">
              指标责任人

            </div>
            <div class="content-content">
              {{contentObj.owner}}
            </div>
          </div>
          <div class="content-txt">
            <div class="content-secondtitle">
              指标定义

            </div>
            <div class="content-content">
              <p
                v-for="(item,index) in definitionTxtList"
                v-show="item!==''"
                :key="index"
              >{{item}}<br /></p>
            </div>
          </div>
          <div class="content-txt">
            <div class="content-secondtitle">
              数据更新频次

            </div>
            <div class="content-content">
              {{contentObj.frequency}}
            </div>
          </div>
          <div class="content-txt">
            <div class="content-secondtitle">
              预警规则

            </div>
            <div class="content-content">
              <p
                v-for="(item,index) in warningTxtList"
                v-show="item!==''"
                :key="index"
              >{{item}}<br /></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['isShow', 'contentObj'],
  data () {
    return {
      closeimg: './Icon/close.png'
    }
  },
  computed: {
    definitionTxtList () {
      let arr = this.contentObj.definition.split('<br/>')
      return arr
    },

    warningTxtList () {
      let arr = this.contentObj.warning.split('<br/>')
      // console.log('arr', arr)
      return arr
    }
  },
  methods: {
    closePop () {
      this.$emit('update:isShow', false)
      this.$store.commit('updataPopShow', false)
    }
  }

}
</script>
<style lang="scss" scope>
@import '../../assets/style/var.scss';
.popup-info {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  .info-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;

    background: rgba(0, 0, 0, 0.5);
    .popup-info-closeicon {
      width: px2rem(40);
      position: absolute;
      top: px2rem(26);
      right: px2rem(40);
    }
    .info-content {
      border-radius: px2rem(10);
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90vw;

      background-color: #07235a;
      .content-title {
        line-height: px2rem(60);
        color: #ffffff;
        font-size: px2rem(32);
        height: px2rem(100);
        line-height: px2rem(100);
        border-bottom: 1px solid $borderColor;
        padding: 0 px2rem(40);
      }
      .content-txt {
        margin-top: px2rem(60);
        font-size: px2rem(28);
        .content-secondtitle {
          color: #6196ca;
        }
        .content-content {
          margin-top: px2rem(22);
          overflow-x: hidden;
          p {
            white-space: normal;
            font-size: px2rem(30);
            color: #ffffff;
            line-height: px2rem(38);
          }
          font-size: px2rem(30);
          color: #ffffff;
        }
      }
      .content-wrap {
        min-height: 50vh;
        padding: 0 px2rem(40);
        max-height: 80vh;
        overflow-y: scroll;
        padding-bottom: px2rem(70);
      }
    }
  }
}
</style>
